<template>
  <div class="bg-gray">
    <div class="form-content">
      <div class="box-operate" v-if="false">
        <el-button type="primary" icon="el-icon-plus" @click="subjectAdd">新增项目</el-button>
      </div>
      <el-form
          :model="formData"
          ref="ruleForm"
          :rules="rules"
          label-width="100px"
          class="demo-ruleForm"
      >
        <div v-for="(subject,index) in row.subject_list ">
          <el-divider>项目信息{{ index + 1 }}</el-divider>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="项目" prop="name">
                <div style="cursor: pointer" @click="openSubjectPicker(subjectOptionsAll,index)">请选择项目 <i
                    class="el-icon-arrow-right"></i></div>
                <div class="form-label-desc" v-show="subject.subject_name">{{ subject.subject_name }}</div>
              </el-form-item>
            </el-col>
            <el-col :span="12">

              <el-form-item label="运动员人数"  v-if="subject.subject_name.indexOf('活力大课间啦啦操展示')>=0">
                <el-input-number style="width: auto !important" v-model="subject.yundongyuan_count" :min="0" :max="3000" />
                <br/> 如果不上传运动员信息，请填写运动员人数
              </el-form-item>

              <el-form-item label="参赛运动员" v-if="subject.subject_name.indexOf('活力大课间啦啦操展示')>=0">
                <div style="cursor: pointer" @click="subject.showYundongyuanPicker=true;thisSubjectIndex=index">方式1：手动选择已注册的运动员
                  <i class="el-icon-arrow-right"></i></div>
                  <div > 
                    方式2：
                    <el-button type="text" @click="download">先下载导入模版</el-button> 
                    <van-uploader
                        accept=".xls,.xlsx"
                        :after-read="readFile"
                    >
                      <el-button 
                        @click="thisSubjectIndex=index"
                          size="normal">再批量导入
                      </el-button>
                    </van-uploader>
                    <p style="color: #666;">运动员姓名将显示在比赛证书上，<span style="color: #ff0000">请谨慎填写<br/>如果不填写运动员，后期将无法导出证书。</span></p>
                  </div>
                    
                <div v-show=subject.yundongyuan.length>
                  <div class="memberLi" v-for="(yundongyuan ,index) in subject.yundongyuan" :key=index>
                    运动员{{ index + 1 }}
                    <el-tag
                        :key="index"
                        round
                        closable
                        type="primary"
                        @close="subject.yundongyuan.splice(index,1)"
                    > {{ yundongyuan.name }} {{ yundongyuan.sex | sex }}
                    </el-tag>
                  </div>
                </div>
              </el-form-item>

              <el-form-item v-else label="参赛运动员"  >
                <div style="cursor: pointer" @click="subject.showYundongyuanPicker=true;thisSubjectIndex=index">选择运动员
                  <i class="el-icon-arrow-right"></i></div>
         
                    
                <div v-show=subject.yundongyuan.length>
                  <div class="memberLi" v-for="(yundongyuan ,index) in subject.yundongyuan" :key=index>
                    运动员{{ index + 1 }}
                    <el-tag
                        :key="index"
                        round
                        closable
                        type="primary"
                        @close="subject.yundongyuan.splice(index,1)"
                    > {{ yundongyuan.name }} {{ yundongyuan.sex | sex }}
                    </el-tag>
                  </div>
                </div>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20" v-if="subject.music_url">
            <!--            <van-cell v-if="subject.music_url" title="规定音乐" value="点击试听" @click="playMusicUrl=subject.music_url;showMusic=true"  is-link>-->
            <!--            </van-cell>-->


            <!--            <van-cell v-if="!subject.music_url" title="自选音乐" :value="subject.music.length+'/1'">-->
            <!--            </van-cell>-->
            <el-col :span="12">
              <el-form-item label="规定音乐">
                <div style="cursor: pointer" @click="playMusicUrl=subject.music_url;subject.music_url_played=true;showMusic=true">点击试听 <i
                    class="el-icon-arrow-right"></i></div>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="替补运动员">
                <div style="cursor: pointer" @click="subject.showTbYundongyuanPicker=true;thisSubjectIndex=index">
                  请选择替补运动员 <i class="el-icon-arrow-right"></i></div>
                <div v-show=subject.tbydy.length>
                  <div class="memberLi" v-for="(yundongyuan ,index) in subject.tbydy" :key=index>
                    替补运动员{{ index + 1 }}
                    <el-tag
                        :key="index"
                        round
                        closable
                        type="primary"
                        @close="subject.tbydy.splice(index,1)"
                    > {{ yundongyuan.name }} {{ yundongyuan.sex | sex }}
                    </el-tag>
                  </div>
                </div>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="教练员">
                <div style="cursor: pointer" @click="subject.showJiaolianPicker=true;thisSubjectIndex=index">请选择教练员 <i
                    class="el-icon-arrow-right"></i></div>
                <div v-show=subject.jiaolian.length>
                  <div class="memberLi" v-for="(yundongyuan ,index) in subject.jiaolian" :key=index>
                    教练员{{ index + 1 }}
                    <el-tag
                        :key="index"
                        round
                        closable
                        type="primary"
                        @close="subject.jiaolian.splice(index,1)"
                    > {{ yundongyuan.name }} {{ yundongyuan.num }}
                    </el-tag>
                  </div>
                </div>
                <div style="line-height: 28px; padding-top: 10px; font-size: 14px;color: #666">此处教练员顺序即为获奖证书的教练员顺序 <span
                    style="color: #ff0000">请谨慎选择</span></div>
              </el-form-item>
            </el-col>
          </el-row>
          <div class="tc">
            <el-button type="default" icon="el-icon-delete" round @click="subjectRemove(subject,index)">
              删除项目{{ index + 1 }}
            </el-button>
          </div>

          <YundongyuanPicker
              :show="subject.showYundongyuanPicker"
              :limit="10000"
              @onChange="onYundongyuanChange"
              @onClose="subject.showYundongyuanPicker=false"
              :defaultValue="subject.yundongyuan"
              @onConfirm="onYundongyuanConfirm"
          ></YundongyuanPicker>
          <YundongyuanPicker
              v-if="row.subject_list.length>0"
              :show="subject.showTbYundongyuanPicker"
              :limit="10000"
              @onChange="onTbYundongyuanChange"
              @onClose="subject.showTbYundongyuanPicker=false"
              :defaultValue="subject.tbydy"
              @onConfirm="onTbYundongyuanConfirm"
          ></YundongyuanPicker>
          <SubjectJiaolianPicker
              :show="subject.showJiaolianPicker"
              :limit="5"
              @onChange="onJiaolianChange"
              @onClose="subject.showJiaolianPicker=false"
              :options="row.jiaolian_options"
              :defaultValue="subject.jiaolian"
              @onConfirm="onJiaolianConfirm"
          ></SubjectJiaolianPicker>
        </div>

        <el-row>
          <el-col class="footer-button">
            <el-button type="default" plain icon="el-icon-plus" @click="subjectAdd">新增项目</el-button>
            <el-button type="primary" @click="onSubmitCheck('ruleForm')" :loading="saveLoading">保存
            </el-button>
            <el-button @click="resetForm('ruleForm')" plain v-if="false">重置</el-button>
          </el-col>
        </el-row>
      </el-form>


      <van-popup v-model="showSubjectPicker" @click-overlay="onSubjectClose" :style="{ width: '60%',paddingTop:'50px'}">
        <van-cell-group>
          <van-cell v-for="(item,index) in subjectOptions" :key="index" is-link @click="onSubjectSelect(item)">
            {{ item.name }}
          </van-cell>
        </van-cell-group>

      </van-popup>

      <el-dialog title="音乐播放" :visible.sync="showMusic" @close="showMusic = false">
        <div style="text-align: center">
          <audio autoplay style="margin: 10px auto" v-if="playMusicUrl&&showMusic" :src="playMusicUrl"
                 controls="controls"></audio>
        </div>
      </el-dialog>


    </div>
  </div>
</template>
<style scoped>
.box {
  /*margin-bottom: 1.5rem;*/
}

.memberResultWrap {
  background: #F3F3F3;
  margin: 0.2rem;
  border-radius: 8px;
  padding: 0.2rem;
}

.memberResultWrap .memberLi {
  font-size: 14px;
  color: #666;
  height: 36px;
  line-height: 36px;
}

.memberResultWrap .memberLi .van-tag {
  width: auto !important;
}

.savebtn {
  position: fixed;
  bottom: 0;
  padding-bottom: 0.2rem;
  width: 100%;
  z-index: 10;
  display: flex;
  flex: 1;
  flex-direction: row;
  justify-content: space-around;
  background: linear-gradient(180deg, hsla(0, 0%, 100%, 0), #fff);
}


.van-tag {
  width: 55px;
  margin-left: 10px;
  text-align: center;
}

.between {
  justify-content: space-between;
}

</style>
<script>
import Vue from 'vue';
import area from "../../../utils/area";
import validator from "../../../utils/validator";
import PicUploader from '@/components/picker/PicUploader.vue';
import FileUploader from '@/components/picker/FileUploader.vue';

import {
  Cell,
  Field,
  Area,
  Form,
  Divider,
  CellGroup,
  RadioGroup,
  Radio,
  Dialog,
  ActionSheet,
  Icon,
  Toast,
  Popup,
  Picker,
  Sidebar,
  SidebarItem,
  Tag,
  Stepper,
  Switch,
  Button
} from 'vant';

import SubjectJiaolianPicker from '@/components/picker/SubjectJiaolianPicker.vue';
import YundongyuanPicker from '@/components/picker/YundongyuanPicker.vue';
import XLSX from "xlsx";


Vue.use(Cell).use(CellGroup).use(Form).use(Divider).use(Area).use(ActionSheet).use(RadioGroup).use(Radio).use(Icon).use(Toast).use(Popup).use(Picker).use(Sidebar).use(SidebarItem).use(Tag).use(Stepper).use(Field)
    .use(Switch).use(Button).use(Dialog);
export default {
  name: 'SaiApplyFormStep2',
  components: {
    [Field.name]: Field,
    PicUploader,
    FileUploader,
    SubjectJiaolianPicker,
    YundongyuanPicker,
  },
  data: function () {
    return {
      validator,
      playMusicUrl: '',
      showMusic: false,
      thisSubjectIndex: 0,
      saveLoading: false,
      showWxShare: false,
      showSubjectPicker: false,
      showNumTypePicker: false,
      show_share_panel: false,
      numTypeColumns: ['身份证', '护照'],
      showArea: false,
      areaList: {},
      rules: {},
      copy_text: 'cccc',
      areaValue: '',
      submitType: '',
      subject_name: '',
      subjectArray: [],
      subjectOptions: [],
      subjectOptionsAll: [
        {
          name: '幼儿组',
          children: [
            {
              name: '幼儿组',
              children: [{
                name: '舞蹈啦啦操',
                children: [
                  {
                    name: '花球规定动作',
                  },
                  {
                    name: '222',
                  }
                ]
              }, {
                name: '余杭区',
                children: [
                  {
                    name: '111',
                  },
                  {
                    name: '222',
                  }
                ]
              }],
            },
            {
              name: '温州',
              children: [{name: '鹿城区'}, {name: '瓯海区'}],
            },
          ],
        },
        {
          name: '福建',
          children: [
            {
              name: '福州',
              children: [{name: '鼓楼区'}, {name: '台江区'}],
            },
            {
              name: '厦门',
              children: [{name: '思明区'}, {name: '海沧区'}],
            },
          ],
        },
      ],
      row: {
        subject_list: [],
        subject_options: [],
      },
      formData: {
        id: 0,
        saiqu_name: 'xxxxx',
        danwei: 'xxxxx',
        caipan: [],
        music: [],
        yundongyuan: [],
        tbydy: [],
        jiaolian: [],
        areas: '',
        province: '',
        city: '',
        county: '',
        kaojitype: '考级中心',
        changdipic: [{
          "uid": "vc-upload-1587109262602680",
          "url": "https://cheeseman.oss-cn-hangzhou.aliyuncs.com/h5/2020-04-17/1587109262602680.jpg",
          "name": "支付宝.jpg",
          "save_name": "h5/2020-04-17/1587109262602680.jpg"
        }],
        zhizhaopic: [{
          "uid": "vc-upload-1587109262602680",
          "url": "https://cheeseman.oss-cn-hangzhou.aliyuncs.com/h5/2020-04-17/1587109262602680.jpg",
          "name": "支付宝.jpg",
          "save_name": "h5/2020-04-17/1587109262602680.jpg"
        }],
      },
    }
  },
  mounted() {
    let that = this;
    that.areaList = area;
    that.formData.id = this.$route.query.id;
    document.title = '补充信息';
    if (that.formData.id) {
      this.fetch();
    }
  },
  watch: {
    formData() {
    }
  },
  destroyed() {
  },
  filters: {
    sex: function (val) {
      switch (val) {
        case 1 :
          return '男';
        case 2 :
          return '女';
        default :
          return ''
      }
    }
  },
  methods: {
    onQuestion() {
      console.log('onQuestion')
    },
    subjectAdd() {
      this.row.subject_list.push({
        showYundongyuanPicker: false,
        showTbYundongyuanPicker: false,
        showJiaolianPicker: false,
        subject_name: '',
        subjectArray: [],
        yundongyuan: [],
        tbydy: [],
        music: [],
        jiaolian: [],
        yundongyuan_count: 0,
      })
    },
    subjectRemove(item, index) {
      let that = this;
      let notice = '确认删除项目' + (item.subject_name ? '(' + item.subject_name + ')' : '') + '吗?';

      this.$confirm(notice, '删除项目', {
        showClose: false,
        closeOnPressEscape: false,
        closeOnClickModal: false,
      }).then(() => {
        if (!item.id) {
          that.row.subject_list.splice(index, 1);
          return
        }

        that.$api.post('/api/isai/subjectDelete', {
          'baoming_id': that.row.id,
          'subject_id': item.id
        }, (res) => {

          that.row.subject_list.splice(index, 1);
        }, (res) => {
          that.$message.error(res.msg);
        })
      }).catch(() => {
      });
    },

    onSubmitCheck(values) {
      this.$confirm('是否需要补报项目', '确认提交', {
        confirmButtonText: '我没有项目要报了',
        cancelButtonText: '我还有项目要报',
        showClose: false,
        closeOnPressEscape: false,
        closeOnClickModal: false,
      }).then(() => {
        this.submitForm(values)
      }).catch(() => {
      });

    },
    submitForm(formName) {

      let that = this;
      console.log(that.formData)
      that.formValidate = true;
      for (let field in that.formData) {

//                    if (that.formData.changdipic.length == 0) {
//                        Toast('请上传场地照片');
//                        return
//                    }
      }
      let valiOk = true;

      that.row.subject_list.map((item, index) => {
        if (!item.subject && item.subjectArray.length == 0) {
          that.$message.info('请选择项目' + (index + 1));
          valiOk = false;
          return;
        }
        if (item.yundongyuan.length == 0) {
          that.$message.info('请完善项目' + (index + 1) + '的运动员信息');
          valiOk = false;
          return;
        }
        if (item.jiaolian.length == 0) {
          that.$message.info('请完善项目' + (index + 1) + '的教练员信息');
          valiOk = false;
          return;
        }
        if (item.music_url_played == false && item.music_url) {
          that.$message.info('请试听项目' + (index + 1) + '的规定音乐');
          valiOk = false;
          return;
        }


        // console.log(item)
      });
      if (!valiOk) {
        return;
      }

      // return
      that.saveLoading = true;

      that.$api.post('/api/isai/subjectsave', {
        'baoming_id': that.row.id,
        'subject_list': JSON.stringify(that.row.subject_list.map(item => {
          return {
            'id': item.id || 0,
            'subject_name': item.subject_name,
            'subject': item.subject || item.subjectArray[item.subjectArray.length - 1].key,
            'yundongyuan': item.yundongyuan,
            'jiaolian': item.jiaolian,
            'tbydy': item.tbydy,
            'music': item.music,
            'yundongyuan_count': item.yundongyuan_count,
          }
        }))
      }, (res) => {
        setTimeout(function () {
          rbLink({
            name: 'ISaiApplyDetail',
            query: {
              id: that.row.id
            }
          })
        }, 50);
        that.saveLoading = false;
      }, (res) => {
        that.$message.error(res.msg);
        that.saveLoading = false;
      })
    },

    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    openSubjectPicker(option, index) {
      this.showSubjectPicker = true;
      this.thisSubjectIndex = index;
      this.subjectOptions = option;

      this.row.subject_list[this.thisSubjectIndex].subject = undefined;
      this.row.subject_list[this.thisSubjectIndex].subjectArray = [];
      this.row.subject_list[this.thisSubjectIndex].subject_name = '';
    },
    onSubjectClose() {
      this.showSubjectPicker = false;
      this.row.subject_list[this.thisSubjectIndex].subject = undefined;
      this.row.subject_list[this.thisSubjectIndex].subjectArray = [];
      this.row.subject_list[this.thisSubjectIndex].subject_name = '';
    },
    onSubjectSelect(item) {
      console.log(item);
      this.row.subject_list[this.thisSubjectIndex].subjectArray.push(item);
      this.row.subject_list[this.thisSubjectIndex].subject_name = this.row.subject_list[this.thisSubjectIndex].subjectArray.map(item => {
        return item.name
      }).join('-')
      if (!item.children || item.children.length == 0) {
        this.showSubjectPicker = false;
        this.onShowMusic();
        return false;
      }
      this.subjectOptions = item.children;
    },
    onShowMusic(){
      let item =this.row.subject_list[this.thisSubjectIndex];
      let subject = item.subjectArray[item.subjectArray.length-1].key
      let that =this;
      console.log('onShowMusic',subject);
      that.$api.post('/api/isai/getSubjectMusic', {
        subject:subject
      }, (res) => {
        console.log(res);
        that.$set(this.row.subject_list[this.thisSubjectIndex],'music_url',res.data.music_url);
        that.$set(this.row.subject_list[this.thisSubjectIndex],'music_url_played',false);
      }, (res) => {
        console.log(res);
        that.$set(this.row.subject_list[this.thisSubjectIndex],'music_url','');
      });
    },
    onYundongyuanConfirm(values) {
      console.log('onYundongyuanConfirm', values)
      // 判断替补运动员是否已存在
      let count = 0
      this.row.subject_list[this.thisSubjectIndex].tbydy.map(member => {
        values.map(row => {
          if (member.name == row.name) {
            Toast.fail(row.name + " 替补运动员中已存在")
            count++
            return
          }
        })
      })
//                this.showYundongyuanPicker = false;
      this.row.subject_list[this.thisSubjectIndex].showYundongyuanPicker = false;
      if (count > 0) return
      this.row.subject_list[this.thisSubjectIndex].yundongyuan = [...values];
    },
    onYundongyuanChange(values) {
      console.log('onYundongyaunChange', values)
      // 判断替补运动员是否已存在
      let count = 0
      this.row.subject_list[this.thisSubjectIndex].tbydy.map(member => {
        values.map(row => {
          if (member.name == row.name) {
            Toast.fail(row.name + " 替补运动员中已存在")
            count++
            return
          }
        })
      })
      if (count > 0) return
      this.row.subject_list[this.thisSubjectIndex].yundongyuan = [...values];
    },
    onTbYundongyuanConfirm(values) {
      console.log('onTbYundongyuanConfirm', values)
      // 判断参赛运动员是否已存在
      let count = 0;
      this.row.subject_list[this.thisSubjectIndex].yundongyuan.map(member => {
        values.map(row => {
          if (member.name == row.name) {
            Toast.fail(row.name + " 参赛运动员中已存在")
            count++
            return
          }
        })
      })
      this.row.subject_list[this.thisSubjectIndex].showTbYundongyuanPicker = false;
      if (count > 0) return
      this.row.subject_list[this.thisSubjectIndex].tbydy = [...values];
    },
    onTbYundongyuanChange(values) {
      console.log('onTbYundongyuanChange', values)
      // 判断参赛运动员是否已存在
      let count = 0;
      this.row.subject_list[this.thisSubjectIndex].yundongyuan.map(member => {
        values.map(row => {
          if (member.name == row.name) {
            Toast.fail(row.name + " 参赛运动员中已存在")
            count++
            return
          }
        })
      })
      if (count > 0) return
      this.row.subject_list[this.thisSubjectIndex].tbydy = [...values];
    },
    onJiaolianConfirm(values) {
      console.log('onJiaolianConfirm', values)
      this.row.subject_list[this.thisSubjectIndex].showJiaolianPicker = false;
      this.row.subject_list[this.thisSubjectIndex].jiaolian = [...values];
    },
    onJiaolianChange(values) {
      console.log('onJiaolianChange', values)
      this.row.subject_list[this.thisSubjectIndex].jiaolian = [...values];
    },
    onNumTypeConfirm(value, index) {
      this.row.subject_list[this.thisSubjectIndex].numTypeName = value;
      this.row.subject_list[this.thisSubjectIndex].numtype = index + 1;
      this.showNumTypePicker = false;
    },
    onSubmit(values) {
      console.log('onSubmit-values', values);
      console.log('submitType', this.submitType);

      let that = this;
      console.log(that.formData)
      that.formValidate = true;
      for (let field in that.formData) {

//                    if (that.formData.changdipic.length == 0) {
//                        Toast('请上传场地照片');
//                        return
//                    }
      }
      let valiOk = true;

      that.row.subject_list.map((item, index) => {
        if (!item.subject && item.subjectArray.length == 0) {
          Toast('请选择项目' + (index + 1));
          valiOk = false;
          return;
        }
        if (item.yundongyuan.length == 0) {
          Toast('请完善项目' + (index + 1) + '的运动员信息');
          valiOk = false;
          return;
        }
        if (item.jiaolian.length == 0) {
          Toast('请完善项目' + (index + 1) + '的教练员信息');
          valiOk = false;
          return;
        }
      });
      if (!valiOk) {
        return;
      }


      that.saveLoading = true;

      that.$api.post('/api/isai/subjectsave', {
        'baoming_id': that.row.id,
        'subject_list': JSON.stringify(that.row.subject_list.map(item => {
          return {
            'id': item.id || 0,
            'subject_name': item.subject_name,
            'subject': item.subject || item.subjectArray[item.subjectArray.length - 1].key,
            'yundongyuan': item.yundongyuan,
            'jiaolian': item.jiaolian,
            'tbydy': item.tbydy,
            'music': item.music,
            'yundongyuan_count': item.yundongyuan_count,
          }
        }))
      }, (res) => {

        appEvent({
          name: 'saiApplyDetailReload',
          query: {}
        });

        setTimeout(function () {
          rbLink({
            name: 'ISaiApplyDetail',
            query: {
              id: that.row.id
            }
          }, 'back')
        }, 50);
        that.saveLoading = false;
      }, (res) => {
        Toast.fail(res.msg);
        that.saveLoading = false;
      })
    },
    save(values) {
      this.submitType = 'save';
    },
    onFailed(errorInfo) {
      console.log('failed', errorInfo);
    },
    submit(values) {
      this.submitType = 'submit';
    },
    fetch() {
      let that = this;
      that.$api.post('/api/isai/step2detail', {
        id: that.formData.id
      }, (res) => {
        that.row = res.data;
        that.subjectOptionsAll = res.data.subject_options;
        that.copy_text = res.data.share_data.url;
        //showYundongyuanPicker
        that.row.subject_list.map(item => {
          that.$set(item, 'subjectArray', []);
          that.$set(item, 'showYundongyuanPicker', false);
          that.$set(item, 'showTbYundongyuanPicker', false);
          that.$set(item, 'showJiaolianPicker', false);
          that.$set(item, 'music_url', item.subject_music.music_url ? item.subject_music.music_url : '');
          that.$set(item,'music_url_played',false);
        });

        that.wxShare(that.row.share_data.title, that.row.share_data.desc, that.row.share_data.url, that.row.share_data.pic_url);
      }, (res) => {
        Toast.fail(res.msg);
      })
    },


    shareWeixinFriend() {
      console.log('shareWeixinFriend')
      let that = this;
      if (window.isApp()) {
        appEvent({
          name: 'shareWeixinFriend',
          query: that.row.share_data
        });
      } else {
        this.showWxShare = true;
        this.show_share_panel = false;
      }
    },

    download(){
      window.open('https://ccago.oss-cn-hangzhou.aliyuncs.com/uploader/%E6%B4%BB%E5%8A%9B%E5%A4%A7%E8%AF%BE%E9%97%B4%E8%BF%90%E5%8A%A8%E5%91%98%E4%BF%A1%E6%81%AF%E5%AF%BC%E5%85%A5%E6%A8%A1%E7%89%88.xlsx', '_blank');
    },
    shareWeixinTimeLine() {
      let that = this;
      if (window.isApp()) {
        appEvent({
          name: 'shareWeixinTimeLine',
          query: that.row.share_data
        });
      } else {
        this.showWxShare = true;
        this.show_share_panel = false;

      }
    },


    readFile(evt) {
      console.log('------readFile------', evt)
      var that = this; 

      let files = {0: evt.file}

      const fileReader = new FileReader();
      fileReader.onload = (ev) => {
        try {
          const data = ev.target.result;
          const workbook = XLSX.read(data, {
            type: 'binary'
          });
          const wsname = workbook.SheetNames[0];//取第一张表
          var list = XLSX.utils.sheet_to_json(workbook.Sheets[wsname]);//生成json表格内容

          if (that.startNum) {
            list = list.splice(that.startNum, list.length)
          }

          list = list.filter(row => {
            return row.hasOwnProperty("姓名") && String(row['姓名']).replace(/\s+/g, '') != ''
          })

          let rlist =[]

          list.map(row => {
            rlist.push({
              name: row['姓名'],
              num: 'n'+row['姓名'], 
              cardtype: 3,
              birthday: '',
              sex: 0,
            })
          })
 
          this.row.subject_list[this.thisSubjectIndex].yundongyuan = [...rlist];

          // that.listData = list 
          // console.log('onGetData', list)
        
          return 
 

        } catch (e) {
          console.log(e)
          return false;
        }
      };
      fileReader.readAsBinaryString(files[0]);
    },

 


  }
}
</script>



// WEBPACK FOOTER //
// SaiApplyFormStep2.vue?bb797714